module.exports = __webpack_public_path__ + "static/offers.fr-05fc8e453e3c21b28f32923d2480fa6b.png";